import { MeterUploadRowStatus, type MeterUploadRow } from "./buildTrialRunRow";
import { newRowId } from "./newRowId";

// A not-yet-persisted Draft row for an inline insert: identity / lookup fields start
// empty (the operator fills them via the inline cells), reading defaults to 0, seq is
// left unset, and the client id is fresh so two inserted rows never share a reference.
// The standalone add-row modal is retired, so a row is always inserted blank.
export const buildNewRow = (): MeterUploadRow => ({
  id: newRowId(),
  status: MeterUploadRowStatus.Draft,
  rowData: {
    accountNumber: "",
    extractionPointName: "",
    serialNo: "",
    readAt: "",
    reading: 0,
    group: "",
    seq: undefined,
  },
});
